import React from "react";
import SocialLinks from "../common/socialLinks/SocialLinks";

const HomePage = () => (
  <div className="row flex-xl-nowrap topRouterWrapper noBackgroundLogo d-flex m-0">
	  <div className="masthead col-md-7 order-md-1 order-2 order-sm-2">
	    <div className="masthead-bg"></div>
	    <div className="container h-100">
	      <div className="row h-100">
	        <div className="col-12 my-auto">
	          <div className="masthead-content text-white py-5">
	            <h1 className="mb-3">Empowering Everyone with Open Source Technologies</h1>
	            <p className="mb-5">Welcome to The Geeky Indian, your gateway to mastering open source technologies. In today&apos;s digital world, open source software powers everything from the websites you visit to the apps on your phone. Our mission is to democratize knowledge and make high-quality programming education accessible to everyone, regardless of their background or location.</p>
	            <p className="mb-5">We believe that learning to code should be an inclusive journey. That&apos;s why we&apos;ve created comprehensive, free tutorials covering popular programming languages like Java and Python. Whether you&apos;re a complete beginner or looking to advance your skills, our step-by-step guides, practical examples, and interactive content will help you build a strong foundation in software development.</p>
	            <p className="mb-5">Join our community of learners and contributors. Explore our tutorials, share your knowledge, and become part of the global open source movement. The future of technology is open, and it&apos;s waiting for you to shape it.</p>
	            <div className="input-group input-group-newsletter">
	              <input type="email" className="form-control" placeholder="Enter email..." aria-label="Enter email..."
	              aria-describedby="basic-addon"/>
	              <div className="input-group-append">
	                <button className="btn btn-secondary" type="button">Subscribe for Updates!</button>
	              </div>
	            </div>
	          </div>
	        </div>
	      </div>
	    </div>
	  </div>
    <div className="col-md-5 order-md-2 order-sm-1 row">
        <div className="m-auto">
          <img src={require('../../../assets/Logo/Icon/FullColor_TransparentBg_1024x1024_72dpi.png')}
            width="400" height="50" className="d-inline-block align-top rotate" alt=""></img>
        </div>
    </div>
	  <SocialLinks/>
  </div>
);

export default HomePage;
